export const environment = {
  production: false,
  configFile: 'config.uat.json'
};
